module.exports = __webpack_public_path__ + "static/media/a.5ea49556.jpg";